import CustomFormDialog from "../CustomFormDialog";

const EditDialog = ({ isOpen, onClose, editInputs, editData, submitEdit }) => {
    return (
        <CustomFormDialog
            title="Edit Item"
            fields={editInputs.map((input) => ({
                ...input,
                value: editData[input.name] || editData,
            }))}
            open={isOpen}
            onClose={onClose}
            formSubmitText="Submit"
            handleSubmitClick={submitEdit}
        />
    );
};

export default EditDialog;
